import { Component, OnInit, ViewChild } from '@angular/core';

import { BehaviorSubject, Observable } from "rxjs";

import { UserTableService } from 'src/service/user.service';

import { CustomerService } from 'src/api/services';
import { User,Customer, CustomerSummary } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services/command.service';
import { Command } from 'src/api/models/command';
import { CommandParameter } from 'src/api/models/command-parameter';

// todo: fix styles
// todo: install license

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.css']
})
export class ControlComponent implements OnInit {

  command: Command = { parameters: [] };
  constructor(public app: ApplicationConfigService, private svc: CommandService, private toasterService: ToastrService) { 
    
  }

  ngOnInit(): void {    
    
  }

  addParameter(){
    this.command.parameters.push({} as CommandParameter);
  }

  removeParameter(p){
    var index = this.command.parameters.indexOf(p);
    if (index > -1) {
      this.command.parameters.splice(index, 1);
    }
  }

  runCommand(){
    debugger;
    this.svc.CommandRunCommand({customerId: this.app.customerId,command: this.command}).subscribe(c => {
          this.toasterService.success("Command Issued");
        }, err => {
          this.toasterService.error("Command Not Issued");

        }
      );
  }
  
  commandIsValid(){
    if (this.command.action == null || this.command.action == '' || this.command.siteUri == null || this.command.siteUri == '') return false;
    for (let param of this.command.parameters){
      if (param.parameterName == null || param.parameterName == '' || param.parameterValue == null || param.parameterValue == '') return false;
    }
    return true;
  }
}
